import { Box, Typography } from "@mui/material";
import { Close, Done } from "@mui/icons-material";

export function ReadOnlyReadyForSaleRadio({
  isReady = false,
}: {
  isReady: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {isReady ? (
        <>
          <Done fontSize="large" color="success" />
          <Typography variant="body1">Ready for sale</Typography>
        </>
      ) : (
        <>
          <Close fontSize="large" color="error" />
          <Typography variant="body1">Not ready for sale</Typography>
        </>
      )}
    </Box>
  );
}
